<template>
	<div id="loginBody">
	    <div class="login">
	        <div class="login_title"><p>日阅通图书销售管理平台</p></div>
	        <div class="login_items">
	            <div class="login_input">
	                <label for="username">用户名</label>
	                <input type="text" id="username" placeholder="请输入用户名" v-model="username">
	            </div>
	            <div class="login_input">
	                <label for="code">密码</label>
	                <input type="password" id="password" placeholder="请输入密码" v-model="password">
	            </div>
	            <a href="javascript:;">
	            	<button type="button" class="login_button" @click="login">登录</button>
	            </a>
	        </div>
	    </div>
	</div>
</template>

<script>
export default{
	name:'login',
	data(){
		return{
			username:'',
			password:''
		}
	},
	methods:{
		login:function(){
			var _this = this;
			$.ajax({
				type: "post",
				url: _this.$store.state.getUrl + "api/manage/login",
				data: JSON.stringify({
					"account": _this.username,
					"password": _this.password,
					"loginSite": "sell"
				}),
				dataType: "json",
				crossDomain: true == !(document.all),
				contentType: "application/json",
				success: function(data) {
					if(data.ret == 10000) {
						_this.$message({
						  message: '登录成功',
						  type: 'success'
						})
						_this.$store.commit('$_setStorage', data.token)
						_this.$store.commit('$_setLogin', '1')
						_this.$router.push({name: 'Index'})
					} else {
						alert(data.status);
					}
				}
			});
		}
	},
	mounted:function(){
		
	}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/login.vue